const theme1 = {
  colors: {
    primaryColor: '#5e50f1',
    inputBorder: '#e3e3e3',
    textColor: '#000',
    dangerColor: '#d32f2f',
    checkboxColor: '#F97664',
    whiteColor: '#fff',
    primaryDisabled: '#DCDCDC',
    lightBorder: '#ccc',
  },
  fonts: {
    primary: `'Poppins', sans-serif`,
  },
};
export default theme1;
